import api, { openApi } from "../../services/api";

const PLAN_CACHE_TTL_MS = 60 * 1000;
const planCache = new Map();

const getCacheKey = (type, payload) => `${type}:${JSON.stringify(payload || {})}`;

const getCached = (key) => {
    const cached = planCache.get(key);
    if (!cached) return null;

    if (Date.now() - cached.timestamp > PLAN_CACHE_TTL_MS) {
        planCache.delete(key);
        return null;
    }

    return cached.data;
};

const setCached = (key, data) => {
    planCache.set(key, {
        data,
        timestamp: Date.now()
    });
};

const usePlans = () => {

    const getPlanList = async (params) => {
        const { data } = await openApi.request({
            url: '/plans/list',
            method: 'GET',
            params
        });
        return data;
    }

    const list = async (params) => {
        const { data } = await api.request({
            url: '/plans/all',
            method: 'GET',
            params
        });
        return data;
    }

    const save = async (data) => {
        const { data: responseData } = await api.request({
            url: '/plans',
            method: 'POST',
            data
        });
        planCache.clear();
        return responseData;
    }

    const update = async (data) => {
        const { data: responseData } = await api.request({
            url: `/plans/${data.id}`,
            method: 'PUT',
            data
        });
        planCache.clear();
        return responseData;
    }

    const remove = async (id) => {
        const { data } = await api.request({
            url: `/plans/${id}`,
            method: 'DELETE'
        });
        planCache.clear();
        return data;
    }

    const getPlanCompany = async (params, id) => {
        const cacheKey = getCacheKey("company", { params, id });
        const cached = getCached(cacheKey);
        if (cached) return cached;

        const { data } = await api.request({
            url: `/companies/listPlan/${id}`,
            method: 'GET',
            params
        });
        setCached(cacheKey, data);
        return data;
    }

    return {
        getPlanList,
        list,
        save,
        update,
        remove,
        getPlanCompany
    }
}

export default usePlans;
